import React from "react";
import styled from "styled-components";
import { breakpoints } from "../styles/theme";
import { ReactComponent as HomeIcon } from "../assets/icons/home.svg";
import { ReactComponent as SearchIcon } from "../assets/icons/search.svg";
import { ReactComponent as NotificationIcon } from "../assets/icons/notification.svg";
import { ReactComponent as MessagesIcon } from "../assets/icons/messages.svg";
import { ReactComponent as SettingsIcon } from "../assets/icons/settings.svg";
import { Link } from "react-router-dom";

const MobileIconLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 28px;
    height: 28px;
  }
  &:hover {
    opacity: 0.7;
  }
`;
const SidebarMobile: React.FC = () => {
  return (
    <MobileContainer>
      <GradientBackground />
      <IconWrapper>
        <MobileIconLink to="/">
          <HomeIcon />
        </MobileIconLink>
      </IconWrapper>

      <IconWrapper>
        <MobileIconLink to="/search">
          <SearchIcon />
        </MobileIconLink>
      </IconWrapper>

      <IconWrapper>
        <MobileIconLink to="/notifications">
          <NotificationIcon />
        </MobileIconLink>
      </IconWrapper>

      <IconWrapper>
        <MobileIconLink to="/messages">
          <MessagesIcon />
        </MobileIconLink>
      </IconWrapper>

      <IconWrapper>
        <MobileIconLink to="/settings">
          <SettingsIcon />
        </MobileIconLink>
      </IconWrapper>
    </MobileContainer>
  );
};

const MobileContainer = styled.div`
  display: none;

  @media (max-width: ${breakpoints.mobile}) {
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.15);
    display: flex;
    position: fixed;
    bottom: 24px; // 下の余白
    left: 32px; // 左の余白
    right: 32px; // 右の余白
    justify-content: space-around;
    background: #f7f7f7;
    border-radius: 9999px; // 角丸
    padding: 14px 0;
    z-index: 10;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  svg {
    width: 24px;
    height: 24px;
    color: rgb(0, 0, 0);
    transition: fill 0.2s;
  }

  &:hover svg {
    color: rgb(117, 117, 117);
  }
`;

const GradientBackground = styled.div`
  display: none;

  @media (max-width: ${breakpoints.mobile}) {
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 200px; // 高さ調整
    background: linear-gradient(to top, #ffffffaa 50%, rgba(255, 255, 255, 0));
    z-index: -1; // モバイルバーより下
    pointer-events: none; // タッチ操作を邪魔しない
  }
`;

export default SidebarMobile;
